"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoidAuth = exports.OAuth = exports.ApiKeyAuth = exports.HttpBearerAuth = exports.HttpBasicAuth = exports.ObjectSerializer = void 0;
__exportStar(require("./feedItem"), exports);
__exportStar(require("./feedItemMedia"), exports);
__exportStar(require("./feedItems"), exports);
var feedItem_1 = require("./feedItem");
var feedItemMedia_1 = require("./feedItemMedia");
var feedItems_1 = require("./feedItems");
var primitives = ["string", "boolean", "double", "integer", "long", "float", "number", "any"];
var enumsMap = {
  "FeedItem.SourceEnum": feedItem_1.FeedItem.SourceEnum,
  "FeedItemMedia.KindEnum": feedItemMedia_1.FeedItemMedia.KindEnum
};
var typeMap = {
  "FeedItem": feedItem_1.FeedItem,
  "FeedItemMedia": feedItemMedia_1.FeedItemMedia,
  "FeedItems": feedItems_1.FeedItems
};
var ObjectSerializer = function () {
  function ObjectSerializer() {}
  ObjectSerializer.findCorrectType = function (data, expectedType) {
    if (data == undefined) {
      return expectedType;
    } else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
      return expectedType;
    } else if (expectedType === "Date") {
      return expectedType;
    } else {
      if (enumsMap[expectedType]) {
        return expectedType;
      }
      if (!typeMap[expectedType]) {
        return expectedType;
      }
      var discriminatorProperty = typeMap[expectedType].discriminator;
      if (discriminatorProperty == null) {
        return expectedType;
      } else {
        if (data[discriminatorProperty]) {
          var discriminatorType = data[discriminatorProperty];
          if (typeMap[discriminatorType]) {
            return discriminatorType;
          } else {
            return expectedType;
          }
        } else {
          return expectedType;
        }
      }
    }
  };
  ObjectSerializer.serialize = function (data, type) {
    if (data == undefined) {
      return data;
    } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
      return data;
    } else if (type.lastIndexOf("Array<", 0) === 0) {
      var subType = type.replace("Array<", "");
      subType = subType.substring(0, subType.length - 1);
      var transformedData = [];
      for (var index = 0; index < data.length; index++) {
        var datum = data[index];
        transformedData.push(ObjectSerializer.serialize(datum, subType));
      }
      return transformedData;
    } else if (type === "Date") {
      return data.toISOString();
    } else {
      if (enumsMap[type]) {
        return data;
      }
      if (!typeMap[type]) {
        return data;
      }
      type = this.findCorrectType(data, type);
      var attributeTypes = typeMap[type].getAttributeTypeMap();
      var instance = {};
      for (var index = 0; index < attributeTypes.length; index++) {
        var attributeType = attributeTypes[index];
        instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type);
      }
      return instance;
    }
  };
  ObjectSerializer.deserialize = function (data, type) {
    type = ObjectSerializer.findCorrectType(data, type);
    if (data == undefined) {
      return data;
    } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
      return data;
    } else if (type.lastIndexOf("Array<", 0) === 0) {
      var subType = type.replace("Array<", "");
      subType = subType.substring(0, subType.length - 1);
      var transformedData = [];
      for (var index = 0; index < data.length; index++) {
        var datum = data[index];
        transformedData.push(ObjectSerializer.deserialize(datum, subType));
      }
      return transformedData;
    } else if (type === "Date") {
      return new Date(data);
    } else {
      if (enumsMap[type]) {
        return data;
      }
      if (!typeMap[type]) {
        return data;
      }
      var instance = new typeMap[type]();
      var attributeTypes = typeMap[type].getAttributeTypeMap();
      for (var index = 0; index < attributeTypes.length; index++) {
        var attributeType = attributeTypes[index];
        instance[attributeType.name] = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type);
      }
      return instance;
    }
  };
  return ObjectSerializer;
}();
exports.ObjectSerializer = ObjectSerializer;
var HttpBasicAuth = function () {
  function HttpBasicAuth() {
    this.username = '';
    this.password = '';
  }
  HttpBasicAuth.prototype.applyToRequest = function (requestOptions) {
    requestOptions.auth = {
      username: this.username,
      password: this.password
    };
  };
  return HttpBasicAuth;
}();
exports.HttpBasicAuth = HttpBasicAuth;
var HttpBearerAuth = function () {
  function HttpBearerAuth() {
    this.accessToken = '';
  }
  HttpBearerAuth.prototype.applyToRequest = function (requestOptions) {
    if (requestOptions && requestOptions.headers) {
      var accessToken = typeof this.accessToken === 'function' ? this.accessToken() : this.accessToken;
      requestOptions.headers["Authorization"] = "Bearer " + accessToken;
    }
  };
  return HttpBearerAuth;
}();
exports.HttpBearerAuth = HttpBearerAuth;
var ApiKeyAuth = function () {
  function ApiKeyAuth(location, paramName) {
    this.location = location;
    this.paramName = paramName;
    this.apiKey = '';
  }
  ApiKeyAuth.prototype.applyToRequest = function (requestOptions) {
    if (this.location == "query") {
      requestOptions.qs[this.paramName] = this.apiKey;
    } else if (this.location == "header" && requestOptions && requestOptions.headers) {
      requestOptions.headers[this.paramName] = this.apiKey;
    } else if (this.location == 'cookie' && requestOptions && requestOptions.headers) {
      if (requestOptions.headers['Cookie']) {
        requestOptions.headers['Cookie'] += '; ' + this.paramName + '=' + encodeURIComponent(this.apiKey);
      } else {
        requestOptions.headers['Cookie'] = this.paramName + '=' + encodeURIComponent(this.apiKey);
      }
    }
  };
  return ApiKeyAuth;
}();
exports.ApiKeyAuth = ApiKeyAuth;
var OAuth = function () {
  function OAuth() {
    this.accessToken = '';
  }
  OAuth.prototype.applyToRequest = function (requestOptions) {
    if (requestOptions && requestOptions.headers) {
      requestOptions.headers["Authorization"] = "Bearer " + this.accessToken;
    }
  };
  return OAuth;
}();
exports.OAuth = OAuth;
var VoidAuth = function () {
  function VoidAuth() {
    this.username = '';
    this.password = '';
  }
  VoidAuth.prototype.applyToRequest = function (_) {};
  return VoidAuth;
}();
exports.VoidAuth = VoidAuth;